<div class="modal-overlay active" id="soldtoSelectionModal">
  <div class="soldto-selection-modal">
    <div class="modal-header">
      <h2 class="modal-title">Select Your Account</h2>
      <!-- <button class="modal-close" *ngIf="this.selectedCustomerNumber !== null" (click)="dismissModal()">×</button> -->
    </div>

    <div class="modal-warning">
      ℹ️ Please select the account you'd like to use for this session.
    </div>

    <div class="modal-content">
      <div class="accounts-section">
        <h3>Available Accounts</h3>
        @for (item of accountsList; track item; let i = $index) {
          <div class="accounts-list">
            <div class="account-option" [ngClass]="{'active' : this.select === i}" (click)="selectSoldTo(item, i)">
              <div class="account-details">
                <h4>{{item.customerName}}</h4>
                <p>Sold-To #: {{item.customerNumber}} | {{item.state}}</p>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="modal-actions">
      <button class="modal-btn save" id="saveSoldToBtn" (click)="saveSoldToSelection()" [disabled]="newSoldTo === null">
        Continue
      </button>
    </div>
  </div>
</div>
